import { render } from "./PenaltyBreakdown.vue?vue&type=template&id=72ff416a&lang=pug"
import script from "./PenaltyBreakdown.vue?vue&type=script&lang=js"
export * from "./PenaltyBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__